import { BroadcastStatus } from '@yandex-360/telemost-sdk/models';

export type { BroadcastData, BroadcastInfo, BroadcastState } from '@yandex-360/telemost-sdk/cloud-api';
export { BroadcastStatus };

export enum BroadcastTutorialStep {
    CREATED = 'CREATED',
    STARTED = 'STARTED',
    FINISHED = 'FINISHED',
    COMPLETED = 'COMPLETED',
}

export type UgcLiveStatus = 'offline' | 'preparing' | 'ready' | 'onair' | 'finished';

interface VHLiveContent {
    xiva_id: string;
    viewers?: number;
    ugc_live_status?: UgcLiveStatus;
    start_time?: number;
}

export interface VHLiveResponse {
    content: VHLiveContent;
}
